import { NoteListHeader } from 'app/agriculture/routes/Notes/NoteList/components/NoteListHeader';
import { NoteListComponent } from 'app/agriculture/routes/Notes/NoteList/components/NoteListComponent';
import { NoteIcon } from 'app/agriculture/icons';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { useMemo, useState } from 'react';
import { useGenericEntityFromId } from 'app/agriculture/queries/entities/useGenericEntityFromId';
import { useNoteResults } from 'app/agriculture/routes/Notes/NoteList/hooks/useNoteResults';

export function NoteListContainer() {
    const [textFilter, setTextFilter] = useState('');
    const [buttonFilterIds, setButtonFilterIds] = useState<string[]>([]);
    const getParent = useGenericEntityFromId();
    const noteResults = useNoteResults(textFilter);

    const filteredNoteResults = useMemo(
        () =>
            Array.from(noteResults.values()).filter((note) => {
                if (buttonFilterIds.length === 0) return true;

                const parent = getParent(note.parentId);

                if (!parent) return buttonFilterIds.includes('The Farm');

                return buttonFilterIds.includes(parent.type);
            }),
        [buttonFilterIds, noteResults, getParent],
    );

    return (
        <ContentBox variant="lg" title="Notes" Icon={NoteIcon}>
            <ContentBox.Section>
                <NoteListHeader
                    onTextFilterChange={setTextFilter}
                    onButtonFilterChange={setButtonFilterIds}
                />
            </ContentBox.Section>
            <ContentBox.Section scrollable>
                <NoteListComponent
                    notes={filteredNoteResults}
                    hasFilterApplied={textFilter.length > 0 || buttonFilterIds.length > 0}
                />
            </ContentBox.Section>
        </ContentBox>
    );
}
